// Copyright (c) 2020 Deere & Company

import './index.scss';

import AuthenticatedPage from '../../common/components/authenticated-page';
import OrdersAvailableToShip from './orders-available-to-ship';
import React from 'react';

function OrdersAvailableToShipPage () {

    return (
        <AuthenticatedPage className="atp-page atp-order-available-to-ship-page">
            <OrdersAvailableToShip />
        </AuthenticatedPage>
    );

}
OrdersAvailableToShipPage.displayNAme = 'OrdersAvailableToShipPage';

export default OrdersAvailableToShipPage;
